__turbopack_context__.v({
  "list": "ProjectList-module-scss-module__MV7lOa__list",
});
